/**
 * Renders the saved products list on the Wishlist page.
 *
 * The wishlist itself only stores product handles (see assets/wishlist.js).
 * This file turns those handles into real product cards by calling Shopify's
 * storefront AJAX API (/products/{handle}.js) for each one, then renders a
 * simple grid with an image, title, price and a Remove button.
 */
(function () {
  var container = document.getElementById('wishlist-products');
  var emptyState = document.getElementById('wishlist-empty');
  if (!container) return;

  function getHandles() {
    if (window.TeezanoWishlist) return window.TeezanoWishlist.getHandles();
    try {
      var raw = localStorage.getItem('teezano:wishlist');
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function removeHandle(handle) {
    if (window.TeezanoWishlist) {
      window.TeezanoWishlist.remove(handle);
    }
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency,
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function buildCard(product) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var comparePrice =
      product.compare_at_price && product.compare_at_price > product.price
        ? '<span class="wishlist-card__compare">' + formatMoney(product.compare_at_price) + '</span>'
        : '';

    var card = document.createElement('div');
    card.className = 'wishlist-card';
    card.innerHTML =
      '<a href="' +
      product.url +
      '" class="wishlist-card__media">' +
      (image
        ? '<img src="' +
          escapeHtml(image) +
          '" alt="' +
          escapeHtml(product.title) +
          '" loading="lazy" width="400" height="400">'
        : '') +
      '</a>' +
      '<div class="wishlist-card__info">' +
      '<a href="' +
      product.url +
      '" class="wishlist-card__title">' +
      escapeHtml(product.title) +
      '</a>' +
      '<div class="wishlist-card__price">' +
      '<span class="wishlist-card__price-now">' +
      formatMoney(product.price) +
      '</span>' +
      comparePrice +
      '</div>' +
      '<div class="wishlist-card__actions">' +
      '<a href="' +
      product.url +
      '" class="wishlist-card__view">View product</a>' +
      '<button type="button" class="wishlist-card__remove" data-remove="' +
      escapeHtml(product.handle) +
      '">Remove</button>' +
      '</div>' +
      '</div>';
    return card;
  }

  function render() {
    var handles = getHandles();

    if (!handles.length) {
      container.hidden = true;
      container.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    container.hidden = false;
    container.setAttribute('aria-busy', 'true');

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var staleHandles = [];
      container.innerHTML = '';

      products.forEach(function (product, i) {
        if (!product) {
          // Product was deleted/unpublished since it was saved - quietly drop it.
          staleHandles.push(handles[i]);
          return;
        }
        container.appendChild(buildCard(product));
      });

      staleHandles.forEach(removeHandle);
      container.removeAttribute('aria-busy');

      if (!container.children.length) {
        container.hidden = true;
        if (emptyState) emptyState.hidden = false;
      }
    });
  }

  container.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-remove]');
    if (!btn) return;
    // removeHandle() dispatches wishlist:updated, which the listener below
    // picks up to re-render - no need to call render() again here.
    removeHandle(btn.getAttribute('data-remove'));
  });

  document.addEventListener('wishlist:updated', render);

  render();
})();
